module.exports = __webpack_public_path__ + "Luggage-gray.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Luggage-gray.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Luggage-gray.png
// module chunks = 15